import { CheckCircle, ClockCountdown, DotsThreeCircle, MinusCircle } from '@phosphor-icons/react';

export type IAttendanceStatus = 'Pending' | 'Present' | 'Late' | 'Absent' | 'Excused' | 'NotYetEnrolled';

interface IAttendanceStatusObject {
  id: number;
  icon: React.ElementType;
  backgroundColor: string;
  color: string;
  text: IAttendanceStatus;
  shortText: string;
}

export interface AttendanceModel {
  id: number,
  description: string,
  feedback: string,
  homeworkSubmit: string,
  attendanceStatus: number,
  studentId: number,
  lessonId: number
};


export const EAttendanceStatusMap: Record<IAttendanceStatus, IAttendanceStatusObject> = {
  Pending: {
    id: 0,
    icon: DotsThreeCircle,
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
    text: 'Pending',
    shortText: 'Pe',
  },
  Present: {
    id: 1,
    icon: CheckCircle,
    backgroundColor: '#E8F5E9',
    color: '#388E3C',
    text: 'Present',
    shortText: 'P',
  },
  Late: {
    id: 2,
    icon: ClockCountdown,
    backgroundColor: '#FEEBEE',
    color: '#D32F2F',
    text: 'Late',
    shortText: 'L',
  },
  Absent: {
    id: 3,
    icon: MinusCircle,
    backgroundColor: '#FEEBEE',
    color: '#D32F2F',
    text: 'Absent',
    shortText: 'A',
  },
  Excused: {
    id: 4,
    icon: MinusCircle,
    backgroundColor: '#FFFDE7',
    color: '#F9A825',
    text: 'Excused',
    shortText: 'E',
  },
  NotYetEnrolled: {
    id: 5,
    icon: MinusCircle,
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
    text: 'NotYetEnrolled',
    shortText: 'NY',
  },
};

// High-performance reverse lookup: maps numeric ID -> string Key
// e.g., { 0: "Pending", 1: "Present", ... }
export const ID_TO_STATUS_KEY_MAP = Object.entries(EAttendanceStatusMap).reduce<Record<number, IAttendanceStatus>>(
  (acc, [key, value]) => ({
    ...acc,
    [value.id]: key as IAttendanceStatus,
  }),
  {}
);
console.log({ID_TO_STATUS_KEY_MAP})
export interface IStudentLessonAttendance {
  lessonId: number;
  title: string;
  date: string;
  timeSlot: string;
  instructorName: string;
  assistantName: string | null;
  status: IAttendanceStatus;
  meta: IAttendanceStatusObject; // Pass styles and icons down directly to the UI
}

export interface IStudentAttendanceSummary {
  pending: number;
  present: number;
  late: number;
  absent: number;
  excused: number;
  notYetEnrolled: number;
  totalLessons: number;
  attendanceRate: number;
  history: IStudentLessonAttendance[];
}